import type { useDesktopLandingData } from '../use-desktop-landing-data';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';
import { BottomMultipleOfferCard } from './bottom-multiple-offer-card';
import { FavouritesDiscoverySection } from './favourites-discovery-section';
import { GeneralInterestDiscoverySection } from './general-interest-discovery-section';
import { LandingPostPrompts } from './landing-post-prompts';
import { LandingTrustBanners } from './landing-trust-banners';
import { MatchingRequestsDiscoverySection } from './matching-requests-discovery-section';
import { MixedRecommendationsDiscoverySection } from './mixed-recommendations-discovery-section';
import { MostPopularDiscoverySection } from './most-popular-discovery-section';
import { NearestSharingPlaceDiscoverySection } from './nearest-sharing-place-discovery-section';
import { NeighbourhoodSocialActions } from './neighbourhood-social-actions';
import { PopularInterestsDiscoverySection } from './popular-interests-discovery-section';
import { RandomInterestDiscoverySection } from './random-interest-discovery-section';
import { RecentLoansDiscoverySection } from './recent-loans-discovery-section';

export function LandingDiscoverySections({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  return (
    <>
      {!isWhiteLabel(WhiteLabel.Refrain) ? <RecentLoansDiscoverySection data={data} /> : null}
      <MixedRecommendationsDiscoverySection data={data} />
      <NearestSharingPlaceDiscoverySection data={data} />
      <MatchingRequestsDiscoverySection data={data} />
      <RandomInterestDiscoverySection data={data} />
      <LandingTrustBanners
        canBecomeAmbassador={data.canBecomeAmbassador}
        insuredUsers={data.insuredUsers}
        user={data.user}
      />
      <MostPopularDiscoverySection data={data} />
      <BottomMultipleOfferCard showTopMultipleOfferCard={data.showTopMultipleOfferCard} />
      <FavouritesDiscoverySection data={data} />
      <PopularInterestsDiscoverySection data={data} />
      <GeneralInterestDiscoverySection data={data} />
      <NeighbourhoodSocialActions neighbourhoodStatus={data.neighbourhoodStatus} />
      <LandingPostPrompts canPublish={data.canPublish} />
    </>
  );
}
